import React from "react";
import { Dialog } from "@mui/material";
import { COLORS } from "./constants";

// ─────────────────────────────────────────────────────────────────────────────
// ManageDestinationsDialog
//
// The on-demand editor behind DestinationsPanel's "Manage" button. Editing
// keys is occasional setup work; watching where the stream goes is constant,
// so the editor lives in a dialog rather than permanently on the page.
//
// This is only the frame now. OutputDestinationsPanel lays out its own header
// (with the close button in a spot of its own), the platform list, the
// scrolling detail pane and the save bar. The close button used to float
// over the panel's top-right corner, which put it on top of "Save Config".
//
// ── Scrolling ────────────────────────────────────────────────────────────────
// The Paper has a FIXED height and never scrolls; the panel's detail pane
// does. That keeps the header and save bar in view however long a platform's
// settings get, which matters most full-screen on a phone, where the old
// layout cut the Add buttons off below the fold.
// ─────────────────────────────────────────────────────────────────────────────

export function ManageDestinationsDialog({ open, onClose, fullScreen, children }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth={false}
      aria-labelledby="manage-destinations-title"
      PaperProps={{
        sx: {
          bgcolor: COLORS.panel,
          backgroundImage: "none",
          color: COLORS.text,
          // Portaled to <body>, outside the dashboard's font settings.
          fontFamily: COLORS.fontSans,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          ...(fullScreen
            ? { borderRadius: 0 }
            : {
                width: "min(1040px, calc(100vw - 64px))",
                height: "min(860px, calc(100vh - 64px))",
                m: 4,
                borderRadius: "20px",
                border: `1px solid ${COLORS.borderStrong}`,
                boxShadow: "0 24px 64px rgba(0,0,0,0.5)"
              })
        }
      }}
      sx={{ "& .MuiBackdrop-root": { bgcolor: "rgba(8,7,24,0.72)", backdropFilter: "blur(4px)" } }}
    >
      {children}
    </Dialog>
  );
}
